// @link https://codepen.io/aaronbushnell/pen/eGVdzv
export default () => {

   
    let box = document.querySelector('.b-expand-box-items')
    let items = document.querySelectorAll('.b-expand-box-item')

    if (!items)
        return

    items.forEach( (item, index) => {


        item.addEventListener('transitionend', (e) => {
            if(e.propertyName == 'flex-basis') {
                
                if(item.classList.contains('--active')) {

                    let w = window.innerWidth
                    let boxWidthOpen = item.offsetWidth
                    var y = item.offsetLeft - ( (window.innerWidth/2)-(boxWidthOpen/2) )
    
    
                    box.scrollTo({
                        left: y,
                        behavior: 'smooth'
                    })
                }
                
            }
        });

        
        item.addEventListener('click', (e) => {

            item.classList.toggle('--active')
           
        })
    })

   
}